<!--
 * @Description: 查看被代理岗位人员数据
 * @Autor: lwq 
 * @Date: 2020-08-15 14:17:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-26 18:13:38
 * @FilePath: \mrc-base-server-view\src\views\data-access-strategy\modules\ViewDataOfEmployeesInTheSamePosition\index.vue
-->
<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <v-card>
      <v-card-text>
        <!-- 头顶 -->
        <showDataAccessHeader @add="add"
                              :showAdd="!readonly"
                              :label="$t('label_View_the_data_of_delegated_personnel')"
                              :readonly="readonly"
                              v-model="dataobj.mrbase_sys_data_strategy_post_onbehalf_is_used" />
        <!-- 中间内容 -->
        <dataCard v-for="(item, index) in list"
                  class="mb-7"
                  :index="index"
                  :key="item.uuid"
                  :readonly="readonly"
                  :list="item"
                  @edit="edit"
                  @deleteItem="deleteItem">
          <template #default="{item}">
            <v-row>
              <v-col cols="12"
                     sm="6">
                <mrc_ess_autoComplete :label="$t('label_agent_position')"
                                      :readonly="true"
                                      positionView
                                      v-model="item.post_uuid"
                                      :prompt_name="company_post">
                </mrc_ess_autoComplete>
              </v-col>
              <v-col cols="12"
                     sm="6">
                <mrc_ess_autoComplete :label="$t('label_delegate_position')"
                                      :readonly="true"
                                      multiple
                                      positionView
                                      v-model="item.onbehalf_post_uuid"
                                      :prompt_name="company_post">
                </mrc_ess_autoComplete>
              </v-col>
              <v-col cols="12">
                <mrc_ess_staffInfo v-model="item.exclude_staff_uuids"
                                   :label="$t('label_Exclude_people')"
                                   defaultRequest
                                   :readonly="true"
                                   filter="1,2,3,5"
                                   item-value="staff_id"
                                   :multiple="true">
                </mrc_ess_staffInfo>
              </v-col>
              <v-col cols="12">
                <tree v-model="item.exclude_function_uuids"
                      :readonly="true"></tree>
              </v-col>
            </v-row>
          </template>
        </dataCard>
        <!-- 弹出框 -->
      </v-card-text>
      <dialogModule v-model="open"
                    :title="$t('label_View_the_data_of_delegated_personnel')"
                    :paramsData="currentItem"
                    @getData="getData" />
      <mrc_ess_submitBtn @success="success"
                         v-if="!readonly"
                         :cancelText="
          $store.state.uuid ? $t('label_cancel') : $t('label_The_previous_step')
        "
                         @cancel="cancel">
      </mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import showDataAccessHeader from '../showDataAccessHeader'
import dialogModule from './dialogModule'
import dataCard from '../dataCard'
import tree from '../tree'
import {
  listData,
  getData,
  updateData,
  addData,
  delData,
} from '@/service/api/data-access-strategy'
export default {
  components: { showDataAccessHeader, dialogModule, dataCard, tree },
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      skeletonloading: true,
      open: false,
      params: null,
      currentItem: {},
      currentIndex: null,
      dataobj: {
        mrbase_sys_data_strategy_post_onbehalf_is_used: '0',
      },
      list: [],
      deleteList: [], //删除的每一项
    }
  },
  validations: {},
  computed: {
    job_post_uuid () {
      //岗位查询
      return {
        prompt_name: 'job_post',
        org_level_uuid: this.$store.state.currentCompany,
      }
    },
    company_post () {
      return {
        prompt_name: 'company_post',
        org_level_uuid: this.$store.state.currentCompany,
      }
    },
    // mrbase_sys_job_post_grade () {
    //   return { prompt_name: 'mrbase_sys_job_post_grade', org_level_uuid: this.$store.state.currentCompany }
    // }
  },
  created () { },
  watch: {},
  async mounted () {
    if (this.$store.state.uuid) {
      //修改
      await this.getList()
    } else {
      //新增
    }
  },
  methods: {
    async getList () {
      if (this.$store.state.uuid) {
        this.skeletonloading = true
        const res = await getData({
          org_level_uuid: this.$store.state.uuid,
          date: 'mrbase_sys_data_strategy_post_onbehalf',
        })
        if (res.code == 200) {
          this.list = res.mrbase_sys_data_strategy_post_onbehalf
            ? res.mrbase_sys_data_strategy_post_onbehalf
            : []
          this.dataobj = res.data ? res.data : {}
          this.dataobj.mrbase_sys_data_strategy_post_onbehalf_is_used
            ? ''
            : (this.dataobj.mrbase_sys_data_strategy_post_onbehalf_is_used =
              '0')
        }
        this.skeletonloading = false
      } else {
      }
    },
    add () {
      this.currentItem = Object.assign({})
      this.currentIndex = null
      this.open = true
    },
    getData (val, type) {
      // 0新增 1修改
      this.params = val
      if (type == 1) {
        this.$set(
          this.list,
          this.currentIndex,
          Object.assign(this.currentItem, val)
        )
      } else {
        this.list.push(val)
      }
    },
    edit (item, index) {
      //修改
      this.currentItem = item
      this.currentIndex = index
      this.open = true
    },
    deleteItem (item, index) {
      //删除
      this.currentItem = item
      this.currentIndex = index
      if (item.uuid) {
        this.deleteList.push({ ...item, type: 'del' })
      }
      this.list.splice(index, 1)
    },
    async success () {
      if (this.$store.state.uuid) {
        //修改
        let arr = [...this.list, ...this.deleteList].map((item) => {
          return { ...item, strategy_uuid: this.dataobj.uuid }
        })
        const res = await updateData({
          '~table~': 'mrbase_sys_data_strategy_post_onbehalf',
          mrbase_sys_data_strategy_post_onbehalf_properties: '004', //查看被代理岗位人员数据 策略uuid
          org_level_uuid: this.$store.state.uuid,
          mrbase_sys_data_strategy_post_onbehalf_is_used: this.dataobj
            .mrbase_sys_data_strategy_post_onbehalf_is_used,
          mrbase_sys_data_strategy_post_onbehalf: arr,
        })
        if (res.code == 200) {
          this.$Message({
            text: this.$t('message_The_modification_was_successful'),
          })
          await this.getList()
          this.$emit('updateSuccess')
        }
        // else {
        //   this.$Message({ text: this.$t(res.msg), color: 'rgba(0, 0, 0, 0.38)' })
        // }
      } else {
        //新增
        this.$emit('success')
      }
    },
    async cancel () {
      if (this.$store.state.uuid) {
        await this.getList()
        this.$emit('updateSuccess')
      }
      else {
        this.$emit('cancel')
      }
    },
  },
}
</script>

<style scoped></style>
